<script>
    import Staff from "./Team/Staff.svelte";

    export let SERVER;

    const fetchStaff = async () => {
		const response = await fetch(SERVER + '/api/staff');
        return await response.json();
	};
</script>

<section id="team" class="container-fluid">
    <div id="team-header" class="d-flex align-items-center justify-content-center mt-5 mb-5 p-4">
        <div class="text-dark">
            <h2 class="text-center">MEET THE TEAM</h2>
            <p>Team members of Hills and Forest</p>
        </div>
    </div>
    
    <div class="row g-3">
        {#await fetchStaff()}
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        {:then responseJson}
            {#each responseJson.data as staff}
            <div class="col-sm-6 col-lg-3">
                <Staff SERVER={SERVER} staff={staff} />
            </div>
            {/each}
        {:catch error}
            <p>An error occurred!</p>
        {/await}
    </div>
</section>

<style>
    #team {
        margin-bottom: 2rem;
        padding-left: 5rem;
        padding-right: 5rem;
    }
</style>
